import { FETCH_STORE_CREDIT_ERROR, FETCH_STORE_CREDIT_SUCCESS } from '../constants'

export default function storeCreditError(state = false, action) {
    switch (action.type) {
        case FETCH_STORE_CREDIT_ERROR:
            return action.error?.errors?.[0]?.errorKey || true
        case FETCH_STORE_CREDIT_SUCCESS:
            return false
        default:
            return state
    }
}
